<style src="vue-select/dist/vue-select.css"></style>
<style>
.table-hover {
    width: 100%;
    table-layout: fixed;
}

.table-sm {
    font-size: 14px;
}
</style>

<template>
    <section class="content">
       <div class="row">
            <div class="col-sm-12">
                <v-data-table :headers="headers" :items="users" :loading="loading"
                    :items-per-page="pagination.itemsPerPage" :page.sync="pagination.page"
                    :server-items-length="totalItems"
                    :footer-props="{ itemsPerPageOptions: [50, 100, 200] }" @update:page="fetchUsers"
                    @update:items-per-page="changeItemsPerPage">
                    <template #item.no="{ item, index }">
                        {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
                    </template>
                    <template #item.pelanggan_id="{ item }">
                        <div class="text-center">
                            {{ item.pelanggan_id }}
                        </div>
                    </template> 
                    <template #item.no_invoice="{ item }">
                        <div class="text-center">
                            {{ item.no_invoice }}
                        </div>
                    </template> 
                    <template #item.bulan_pemakaian="{ item }">
                        <div class="text-center">
                            {{ item.bulan_pemakaian }}
                        </div>
                    </template> 
                    <template #item.total="{ item }">
                        <div class="text-right">
                            {{ formatRupiah(item.total) }}
                        </div>
                    </template>
                    <template #item.total_bayar="{ item }">
                        <div class="text-right">
                            {{ formatRupiah(item.total_bayar) }}
                        </div>
                    </template>
                </v-data-table>
            </div>
       </div>
    </section>
</template>

<script>

import { formatRupiah } from '../../helpers/format'
export default {
    props: {
        data: {
        type: Object,
        required: true
        }
    },
    watch: {
        data: {
            handler() {
                this.fetchUsers()
            },
            immediate: true, // langsung panggil saat mounted
            deep: true
        }
    },
    data() {
        return {
            user: this.$gate.user,
            users: [],
            totalItems: 0,
            loading: false,
            pagination: {
                page: 1,
                itemsPerPage: 50
            },
            headers: [
                { text: 'No', value: 'no', sortable: false, width: '30px', align: 'center' },
                { text: 'ID ', value: 'id', sortable: true, class: 'text-center', width: '60px' },
                { text: 'Nama', value: 'nama', sortable: true, width: '190px' },
                { text: 'No.Invoice', value: 'no_invoice', sortable: true, class: 'text-center', width: '100px' },
                { text: 'Periode', value: 'bulan_pemakaian', sortable: true, class: 'text-center', width: '100px' },
                { text: 'Nilai Tagihan', value: 'total', sortable: true, class: 'text-right', width: '100px' },
                { text: 'Nilai Paid', value: 'total_bayar', sortable: true, class: 'text-center', width: '100px' },
               
                { text: 'Tanggal Transaksi', value: 'tanggal_bayar', sortable: true, class: 'text-center', width: '100px' },
            ]
        }
    },
    // mounted() {
    //     this.fetchUsers()
    // },
    methods: {
        formatRupiah,
        async fetchUsers() {
            this.loading = true
            try {
                const res = await axios.get('api/keuangan/detail_rekap_closing_online', {
                    params: {
                        page: this.pagination.page,
                        per_page: this.pagination.itemsPerPage,
                        id_user: this.data.status_bayar_by,
                        periode: this.data.periode || null,
                        kantor_id: this.data.kantor_id || null,
                        tipe: this.data.tipe_langganan || null
                    }
                })

                this.users = res.data.data
                this.totalItems = res.data.total
            } catch (e) {
                console.error(e)
            } finally {
                this.loading = false
            }
        },
        changeItemsPerPage(perPage) {
            this.pagination.itemsPerPage = perPage
            this.pagination.page = 1
            this.fetchUsers()
        }
    }
}
</script>